module.exports = __webpack_public_path__ + "img/route-marker-turn.daa98c14.svg";